function sanitizeHtml(input: string): string {
  let output = input.replace(/<[^>]*>?/gm, '');
  output = output.replace(/&[^;]+;/g, '');
  output = output.replace(/\s\s+/g, ' ');
  return output;
}

export default sanitizeHtml;
